export function Logo({ className = "h-8" }) {
  return (
    <img
      src="/images/hireqix-logo.webp"
      alt="hireqix"
      // The wordmark is deep navy, so on dark surfaces it needs a light chip to stay legible.
      className={`${className} w-auto object-contain dark:rounded-md dark:bg-white dark:px-1.5 dark:py-1`}
      data-testid="hireqix-logo"
    />
  );
}
